import { EntityInstanceModel } from '@models/module/entityInstance';

export type ProgressPaymentOnPeriod = {
  status: string;
  stateTypeListElmntConstId?: number;
  color: string;
  textColor: string;
  isDraft: boolean;
  amount: number;
  documentNumber: string;
  sov: string;
};

export type PaymentPeriodModel = {
  id: number;
  contractId: number;
  scheduleId: number;
  startDate: string;
  endDate: string;
  durationDays: number;
  amount: number;
  hasMultiplePayments: boolean;
  isDraft: boolean;
  entityInstances?: EntityInstanceModel[];
  isMultiplePeriod: boolean;
  status?: string;
  entityInstanceId?: number;
  stateTypeListElmntConstId?: number;
  color?: string;
  textColor?: string;
  allowsPaymentRequest: boolean;
  /** Only the last period of the schedule, and only past the contract completion date. */
  allowsDelete: boolean;
  completedPaymentsExistAfter: boolean;
  pendingPaymentsExistBefore: boolean;
  /** Survivor of a combine — the only kind that can be split back. */
  isJoined: boolean;
  existsProgressPayments: boolean;
  sovEntityInstanceId?: number;
  sovIdentifier?: string;
  progressPayments?: ProgressPaymentOnPeriod[];
};

/**
 * Create, Update and Delete answer 200 with a `message` when the stored procedure refused the change.
 * A non-empty message is a soft failure and must be surfaced as a warning, not a success.
 */
export type PaymentPeriodCUDResponse = {
  message?: string;
};
